import { mapGetters } from "vuex";
import { stringHelper } from "@/components/mixins/stringHelper"

import { LiftLinkFormType, ILiftLinkForm } from "../../../Types";

export default {
  props: {
    formData: {
      type: ILiftLinkForm,
      required: false
    },
    liftLinkConfiguration: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      orderingDealerContactEmailAddress: '',
      additionalComments: '',
      liftLinkFormType: LiftLinkFormType.LiteForm,
      orderingDealerContactName: '',
      orderingDealerContactPhoneNumber: '',
      dealerSalesRepEmail: '',
    };
  },
  mixins: [stringHelper],
  computed: {
    ...mapGetters(["user", "getContentItem"]),

    isFormValid() {
      return this.isEmailValid(this.dealerSalesRepEmail)
      && this.isEmailValid(this.orderingDealerContactEmailAddress)
      && this.orderingDealerContactName !== ''
      && this.orderingDealerContactPhoneNumber !== '';
    },
  },
  created() {
    this.dealerSalesRepEmail = this.user.Email;
    if (this.formData) {
      this.dealerSalesRepEmail = this.formData.DealerContactEmail;
      this.orderingDealerContactEmailAddress = this.formData.orderingDealerContactEmailAddress;
      this.orderingDealerContactPhoneNumber = this.formData.orderingDealerContactPhoneNumber;
      this.orderingDealerContactName = this.formData.orderingDealerContactName;
      this.additionalComments = this.formData.additionalComments;
      this.orderingDealerContactName = this.formData.customerContactName;
      this.dealerSalesRepEmail = this.formData.dealerSalesRepEmail || '';
      this.billingContactEmail = this.formData.billingContactEmail || '';
      this.billingSubscriptionOption = this.formData.billingSubscriptionOption || '';
    }
    this.updateLiftLinkFormContext(); 
  },
  methods: {
    updateLiftLinkFormContext() {
      if (this.isFormValid) {
      
        const formData = {
          DealerContactEmail: this.DealerContactEmail,
          CustomerEmail: this.CustomerEmail,
          CustomerName: this.CustomerName,
          selectedSubscriptionOption: this.selectedSubscriptionOption,
          additionalComments: this.additionalComments,
          submissionType: this.liftLinkFormType,
          customerContactName: this.customerContactName,
          customerPhoneNumber: this.customerPhoneNumber,
          dealerSalesRepEmail: this.dealerSalesRepEmail,
          billingContactEmail: this.billingContactEmail,
          billingSubscriptionOption: this.billingSubscriptionOption,
          orderingDealerContactEmailAddress: this.orderingDealerContactEmailAddress,
          orderingDealerContactPhoneNumber: this.orderingDealerContactPhoneNumber,
          orderingDealerContactName: this.orderingDealerContactName,
        };
        this.$emit('formSubmitted', formData);
      } else {
        this.$emit('formInvalid');
      }
    },
  }
};